import noop from 'lodash/noop';
import { fg } from '@atlassian/jira-feature-gating';
import { getUpdateAnalyticsFlowHelper } from '@atlassian/jira-issue-analytics/src/services/update-issue-field/index.tsx';
import { useAnalyticsEvents } from '@atlassian/jira-product-analytics-bridge';

export const useContextStartAnalytics = ({
	selectedCardIds,
	fieldType,
	fieldKey,
}: {
	selectedCardIds: number[];
	fieldType: string;
	fieldKey: string;
}) => {
	const { createAnalyticsEvent } = useAnalyticsEvents();

	if (!fg('one_event_rules_them_all_fg')) {
		return noop;
	}
	return () => {
		if (selectedCardIds.length === 1) {
			getUpdateAnalyticsFlowHelper().fireAnalyticsStart(fieldKey, {
				analytics: createAnalyticsEvent({}),
				attributes: {
					fieldType,
				},
			});
		}
	};
};
